import React, { useState } from 'react';
import '../../assets/css/admin/login.css';
import Img from '../../assets/images/skillslogo.png';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from 'axios';
import Swal from 'sweetalert2';

// Create an axios instance with custom configuration
const api = axios.create({
  baseURL: 'https://api.myskills.lk',
  timeout: 8000, // 8 seconds timeout
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add response interceptor for error handling
api.interceptors.response.use(
  response => response, // Return successful responses as-is
  error => {
    console.error('API Error Occurred:', error);
    // For network errors (server down)
    if (error.code === 'ERR_NETWORK') {
      return Promise.reject({
        ...error,
        customMessage: 'Network error: Unable to connect to the server. Please ensure the backend is running.'
      });
    }
    
    // For 500 errors (server error)
    if (error.response && error.response.status === 500) {
      // Try to extract useful information from the error
      const serverMessage = 
        error.response.data?.message || 
        error.response.data?.error || 
        'The server encountered an internal error. Check server logs for details.';
      
      return Promise.reject({
        ...error, 
        customMessage: `Server Error (500): ${serverMessage}`
      });
    }
    
    // For other errors
    return Promise.reject(error);
  }
);

// Removed inline styles - using CSS from login.css

const Login = () => {    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
      const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Get form values
        const email = e.target.email.value.trim();
        const password = e.target.password.value;
        
        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setErrorMessage("Please enter a valid email address");
            Swal.fire({
                title: "Invalid Email",
                text: "Please enter a valid email address",
                icon: "warning",
            });
            return;
        }
        
        // Password validation - ensure it's not empty
        if (!password || password.length < 1) {
            setErrorMessage("Password cannot be empty");
            Swal.fire({
                title: "Password Required",
                text: "Please enter your password",
                icon: "warning",
            });
            return;
        }
        
        setIsLoading(true);
        setErrorMessage('');
        
        loginUser(email, password);
    };
    
    const loginUser = async (email, password) => {
        try {
            setErrorMessage("Attempting login...");
              // Use our enhanced API instance instead of direct axios
            console.log("Sending login request with:", { email });
            const response = await api.post('/admin/login', { 
                email: email, 
                password: password 
            });
            
            // Log the response structure to debug
            console.log("Login response received:", response.data);
            
            setIsLoading(false);
            setErrorMessage('');
              if (!response.data.success) {
                Swal.fire({
                    title: "Invalid Email or Password",
                    text: "Please check your credentials and try again.",
                    icon: "error",
                });
                return;
            }
              // Successful login
            // The backend returns user object inside response.data.user
            sessionStorage.setItem('aid', response.data.user.id);
            sessionStorage.setItem('aname', response.data.user.name);
            
            Swal.fire({
                title: "Login Successful",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
            }).then(() => {
                window.location.href = "/admindc";
            });
              } catch (error) {
            setIsLoading(false);
            
            // Simple error logging without exposing details to users
            console.error('Login Error:', error);
            
            // Show a simplified error message for any error type
            if (error.response && error.response.status === 401) {
                // Only for 401 unauthorized errors, show invalid credentials message
                setErrorMessage("Invalid email or password");
                
                Swal.fire({
                    title: "Login Failed",
                    text: "Invalid email or password. Please try again.",
                    icon: "error",
                });
            } else {
                // For all other errors (network, server, etc)
                setErrorMessage("Login failed. Please try again later.");
                
                Swal.fire({
                    title: "Login Failed",
                    text: "We couldn't process your login. Please try again later.",
                    icon: "error",
                });
            }
        }
    };

    

    return (
        <div className="login-container">
            <div className="login-box">
                <div className="logo-section">
                    <a href="/"><img src={Img} alt="logo.png" width={150} /></a>
                </div>                <h2>ADMIN LOGIN</h2>                
                <form onSubmit={handleSubmit} noValidate>
                    <div className="input-group">
                        <label htmlFor="email">Email Address</label>                        <input 
                            type="email" 
                            id="email" 
                            name="email" 
                            placeholder="Enter your email address"
                            autoComplete="email"
                            autoFocus
                        />
                        <small className="form-text">We'll never share your email with anyone else.</small>
                    </div>
                    <div className="input-group password-container">
                        <label htmlFor="password">Password</label>                        <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            name="password"
                            placeholder="Enter your password"
                            autoComplete="current-password"
                        />
                        <span
                            className="toggle-visibility"
                            onClick={togglePasswordVisibility}
                            title={showPassword ? "Hide password" : "Show password"}
                            aria-label={showPassword ? "Hide password" : "Show password"}
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>                      {errorMessage && (
                        <div className="error-message">
                            {errorMessage}
                        </div>
                    )}                    <button 
                        type="submit" 
                        className="login-button"
                        disabled={isLoading}
                    >
                        {isLoading ? "Please wait..." : "Sign In"}
                    </button>
                </form>

            </div>
        </div>
    );
};

export default Login;
